import { Box, Card, Grid, IconButton, Slide, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import addusermobile from "../../../Assets/addusermobile.svg";
import MobileIndustrySectorDropdown from "../../AiLeads/IndustrySectorDropdown/MobileIndustrySectorDropdown";

const MFavOrgInnerTable = ({
  openTableDrawer,
  setOpenTableDrawer,
  isTabPortrait,
  innerDataNew,
  clickHandler,
  IndustryDropdown,
  pageInner,
  pages,
  loadMore,
  showLoading,
  selectedOrganizationData,
  handleRowSelect,
}) => {
  const getColor = (score) => {
    if (score > 80) return "green";
    if (score >= 50) return "yellow";
    if (score < 50) return "red";
    return null;
  };

  // Sort the data
  const sortedData = innerDataNew?.slice().sort((a, b) => {
    if (a.decision_maker && !b.decision_maker) return -1;
    if (!a.decision_maker && b.decision_maker) return 1;
    return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
  });

  return (
    <>
      <Slide
        direction="left"
        in={openTableDrawer?.id}
        mountOnEnter
        unmountOnExit
        style={{ paddingTop: "133px" }}
      >
        <Box
          sx={{
            position: "fixed",
            top: isTabPortrait ? "33px" : "0",
            left: isTabPortrait ? "" : "0",
            width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
            right: isTabPortrait ? "0px" : "",
            height: "100%",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <div className="p-2 aip-path-slide-box">
            {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              py={1.5}
            >
              <IconButton></IconButton>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                style={{ textTransform: "capitalize" }}
              >
                {openTableDrawer?.name || "Organizations"}
              </Typography>
              <IconButton onClick={() => setOpenTableDrawer()}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Cards Container */}
            <div>
              {sortedData && sortedData.length > 0 ? (
                sortedData.map((row, index) => {
                  const orgDetails = row.organization_details || {};
                  const leads = row.leads || {};

                  return (
                    <Card
                      key={index}
                      sx={{
                        borderRadius: 3,
                        boxShadow: 2,
                        p: 2,
                        position: "relative",
                        mb: 2,
                        background: selectedOrganizationData?.some(
                          (i) =>
                            i?.organization_details?.org_id ===
                            row?.organization_details?.org_id,
                        )
                          ? "#c0dae6"
                          : "#fff",
                        // checked={selectedOrganizationData?.some(
                        //             (item) =>
                        //               item?.organization_details?.org_id ===
                        //               row?.organization_details?.org_id,
                        //           )}
                      }}
                    >
                      {/* Top Section */}
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                      >
                        <Box>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ textTransform: "capitalize", fontSize: 16 }}
                            onClick={() => handleRowSelect(row)}
                          >
                            {orgDetails.name || "-"}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {orgDetails.city || "-"}, {orgDetails.state || "-"}
                          </Typography>
                        </Box>
                        <IconButton>{/* Star icon placeholder */}</IconButton>
                      </Box>

                      {/* Score + Icons */}
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mt={1}
                      >
                        <div className="kjhgf">
                          <div
                            className="ai-score-background"
                            style={{
                              background:
                                getColor(orgDetails.ai_score) === "red"
                                  ? "#DA291C"
                                  : getColor(orgDetails.ai_score) === "yellow"
                                    ? "#EAB121"
                                    : getColor(orgDetails.ai_score) === "green"
                                      ? "#0EB93E"
                                      : "#ccc",
                            }}
                          >
                            {orgDetails?.ai_score !== null &&
                            orgDetails?.ai_score !== undefined
                              ? orgDetails?.ai_score
                              : "NA"}
                          </div>
                        </div>
                        {/* <Box display="flex" gap={1}>
                          <IconButton
                            sx={{ color: "red", border: "1px solid #cbc9c9" }}
                            onClick={() => clickHandler(orgDetails)}
                          >
                            <VisibilityIcon style={{ color: "#DA291C" }} />
                          </IconButton>
                          <IconButton
                            sx={{ color: "red", border: "1px solid #cbc9c9" }}
                          >
                            <img src={addusermobile} alt="" />
                          </IconButton>
                        </Box> */}
                      </Box>

                      {/* Info Grid */}
                      <Grid container spacing={2} mt={0}>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Employee Size
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {orgDetails.num_employees || "-"}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Annual Revenue
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {orgDetails.revenue_range || "-"}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Industry/Sector
                          </Typography>
                          <MobileIndustrySectorDropdown row={orgDetails} />
                        </Grid>

                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Employees
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            {leads.people_count || "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Card>
                  );
                })
              ) : (
                <Box textAlign="center" py={4}>
                  <Typography variant="body1" color="text.secondary">
                    No records found
                  </Typography>
                </Box>
              )}

              {/* Load More Button */}
              {innerDataNew?.length >= 20 && pageInner <= Math.ceil(pages) && (
                <div className="loadmore-pagination-section">
                  <button
                    className="btn-load-more button-loadmore-pagination"
                    onClick={loadMore}
                    style={{
                      width: "100%",
                      padding: "12px",
                      marginTop: "16px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      background: "white",
                      cursor: "pointer",
                    }}
                  >
                    {showLoading ? "Loading..." : "Load More"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </Box>
      </Slide>
    </>
  );
};

export default MFavOrgInnerTable;
